import { withTheme } from 'styled-components'

export const HeaderIconError = withTheme((props) => (
	<svg {...props} width='121' height='129' viewBox='0 0 121 129' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M60.5 128.5C93.9132 128.5 121 101.233 121 67.5968C121 33.9609 93.9132 6.6936 60.5 6.6936C27.0868 6.6936 0 33.9609 0 67.5968C0 101.233 27.0868 128.5 60.5 128.5Z'
			fill='#005E5D'
		/>
		<mask
			id='mask0_1061_8666'
			style={{ maskType: 'alpha' }}
			maskUnits='userSpaceOnUse'
			x='0'
			y='0'
			width='121'
			height='129'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M121 0.5H0V67.1016V83.752H2.25107C9.40246 109.571 32.773 128.5 60.5 128.5C88.227 128.5 111.598 109.571 118.749 83.752H121V67.1016V0.5Z'
				fill='white'
			/>
		</mask>
		<g mask='url(#mask0_1061_8666)'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M86.5101 0.947722C89.3159 0.578869 92.2971 1.7335 94.4964 3.50976C96.6957 5.28601 97.9219 7.52952 98.1564 10.3539L108.237 156.09C108.611 162.12 104.046 167.331 98.0291 167.743L28.3948 172.728C22.3803 173.178 17.1511 168.667 16.7021 162.643L6.81576 17.4534C6.4414 11.4235 10.8587 6.34437 16.8758 5.93256L86.5101 0.947722Z'
				fill='url(#paint0_linear_1061_8666)'
				fillOpacity='0.5'
			/>
			<path
				d='M15.1084 12.5C15.1084 6.97715 19.5855 2.5 25.1084 2.5H95.8918C101.415 2.5 105.892 6.97715 105.892 12.5V159.855C105.892 165.378 101.415 169.855 95.8917 169.855H25.1084C19.5855 169.855 15.1084 165.378 15.1084 159.855V12.5Z'
				fill='url(#paint1_linear_1061_8666)'
				stroke='#004C4C'
				strokeWidth='4'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M48.4004 14.9517C48.4004 13.8115 49.3247 12.8872 50.4649 12.8872H70.5359C71.6761 12.8872 72.6004 13.8115 72.6004 14.9517C72.6004 16.0919 71.6761 17.0162 70.5359 17.0162H50.4649C49.3247 17.0162 48.4004 16.0919 48.4004 14.9517Z'
				fill='#004C4C'
			/>
			<mask
				id='mask1_1061_8666'
				style={{ maskType: 'alpha' }}
				maskUnits='userSpaceOnUse'
				x='13'
				y='0'
				width='95'
				height='172'
			>
				<path
					d='M15.1084 12.5C15.1084 6.97715 19.5855 2.5 25.1084 2.5H95.8918C101.415 2.5 105.892 6.97715 105.892 12.5V159.855C105.892 165.378 101.415 169.855 95.8917 169.855H25.1084C19.5855 169.855 15.1084 165.378 15.1084 159.855V12.5Z'
					fill='url(#paint2_linear_1061_8666)'
					stroke='#004C4C'
					strokeWidth='4'
				/>
			</mask>
			<g mask='url(#mask1_1061_8666)'>
				<path
					opacity='0.3'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M107.892 0.5L13.1084 172.887V0.5H107.892Z'
					fill='#808080'
				/>
			</g>
		</g>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M58.2372 98.5644C72.7162 98.5644 84.4538 86.5483 84.4538 71.7257C84.4538 56.9031 72.7162 44.887 58.2372 44.887C43.7581 44.887 32.0205 56.9031 32.0205 71.7257C32.0205 86.5483 43.7581 98.5644 58.2372 98.5644Z'
			fill='#005E5D'
			fillOpacity='0.3'
		/>
		<path
			d='M61.2626 95.4677C75.7416 95.4677 87.4792 83.4516 87.4792 68.629C87.4792 53.8064 75.7416 41.7903 61.2626 41.7903C46.7835 41.7903 35.0459 53.8064 35.0459 68.629C35.0459 83.4516 46.7835 95.4677 61.2626 95.4677Z'
			fill='white'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M49.7828 56.8774C48.956 57.7239 48.9545 59.0963 49.7828 59.9443L58.7704 69.1452L49.7828 78.346C48.9545 79.194 48.956 80.5665 49.7828 81.413C50.6097 82.2594 51.9503 82.261 52.7787 81.413L61.7663 72.2121L70.7539 81.413C71.5822 82.261 72.9229 82.2594 73.7497 81.413C74.5766 80.5665 74.5781 79.194 73.7497 78.346L64.7621 69.1452L73.7497 59.9443C74.5781 59.0963 74.5766 57.7239 73.7497 56.8774C72.9229 56.0309 71.5822 56.0294 70.7539 56.8774L61.7663 66.0782L52.7787 56.8774C51.9503 56.0294 50.6097 56.0309 49.7828 56.8774Z'
			fill='#C21700'
		/>
		<defs>
			<linearGradient
				id='paint0_linear_1061_8666'
				x1='-15.4535'
				y1='86.4027'
				x2='97.9965'
				y2='136.715'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopOpacity='0.13' />
				<stop offset='1' stopOpacity='0.28' />
			</linearGradient>
			<linearGradient
				id='paint1_linear_1061_8666'
				x1='62.5314'
				y1='-57.5415'
				x2='-42.4779'
				y2='7.47034'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#00C5BC' />
				<stop offset='1' stopColor='#009286' />
			</linearGradient>
			<linearGradient
				id='paint2_linear_1061_8666'
				x1='62.5314'
				y1='-57.5415'
				x2='-42.4779'
				y2='7.47034'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#00C5BC' />
				<stop offset='1' stopColor='#009286' />
			</linearGradient>
		</defs>
	</svg>
))
